export const SCHEMAS = {
  project: {
    title: { type: 'string', minLength: 3, required: true },
    location: { type: 'string', required: false },
    contractor: { type: 'string', required: false }
  },
  soilTest: {
    wInitialSand: { type: 'number', min: 100, required: true },
    wRemainSand: { type: 'number', min: 0, required: true },
    wCone: { type: 'number', min: 0, required: true },
    sandDensity: { type: 'number', min: 0.5, max: 3.5, required: true },
    wWetSoil: { type: 'number', min: 100, required: true },
    moisture: { type: 'number', min: 0, max: 60, required: true },
    maxDryDensity: { type: 'number', min: 0.8, max: 3.5, required: true }
  },
  quantitySheet: {
    items: {
      type: 'array',
      minLength: 1,
      required: true,
      validator: (items) => {
        return items.every(item => 
          (item.length || 0) >= 0 && 
          (item.width || 0) >= 0 && 
          (item.height || 0) >= 0 && 
          (item.count || 0) > 0
        );
      }
    }
  }
};

export const schemaValidator = {
  validate: (schemaName, data) => {
    const schema = SCHEMAS[schemaName];
    if (!schema) return true;

    for (const [key, rules] of Object.entries(schema)) {
      const val = data[key];
      if (rules.required && (val === undefined || val === null || val === '')) {
        throw new Error(`فیلد الزامی [${key}] تکمیل نشده است.`);
      }
      if (val !== undefined && val !== null) {
        if (rules.type === 'number') {
          const num = Number(val);
          if (isNaN(num)) throw new Error(`فیلد [${key}] باید مقدار عددی باشد.`);
        }
      }
    }
    return true;
  }
};
